import { green, grey, orange, red } from "@mui/material/colors"
import { BackgroundColorRule, PaletteColorRule, TextColorRule } from "../ColorRules"

export default {
  primary: new PaletteColorRule("#e8f1fa", "#1f82c5", "#022d4b", "#ffffff"),
  secondary: new PaletteColorRule("#fce0c2", "#f49f45", "#eb704e", "#ffffff"),
  error: new PaletteColorRule(red[300], red[500], red[800], "#ffffff"),
  warning: new PaletteColorRule(orange[300], orange[500], orange[800], "#ffffff"),
  info: new PaletteColorRule(grey[100], grey[300], grey[500], grey[800]),
  success: new PaletteColorRule(green[100], green[500], green[800], "#ffffff"),
  text: new TextColorRule("#000000", "#000000", "#878787"),
  divider: "#000000",
  background: new BackgroundColorRule("#ffffff", "#f2f2f2")
}